/**
 * Route availability evaluation — reuses MVP / feature / mock / future rules.
 */

/**
 * @returns {{ available: boolean, reason?: 'mvp'|'mock-only'|'future'|'prototype'|'unknown' }}
 */
export function evaluateRouteAvailability(page, {
  isRouteAllowedInMvp,
  isMockOnlyPage,
  isFuturePage,
  isPrototypeRoute,
  showFuturePages = true,
} = {}) {
  if (!page) return { available: false, reason: 'unknown' };

  if (typeof isMockOnlyPage === 'function' && isMockOnlyPage(page)) {
    return { available: false, reason: 'mock-only' };
  }
  if (typeof isFuturePage === 'function' && isFuturePage(page) && !showFuturePages) {
    return { available: false, reason: 'future' };
  }
  if (typeof isRouteAllowedInMvp === 'function' && !isRouteAllowedInMvp(page)) {
    return { available: false, reason: 'mvp' };
  }
  // Existing product asymmetry: integrations/observabilidade OutOfMvp when prototype;
  // repairs still renders even when prototype (FEATURE_REPAIRS_MODULE false).
  if (
    typeof isPrototypeRoute === 'function'
    && isPrototypeRoute(page)
    && (page === 'integrations' || page === 'observabilidade')
  ) {
    return { available: false, reason: 'prototype' };
  }
  return { available: true };
}
